/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { transition, style, animate } from "@angular/animations";
export function fade(opacity) {
    "use strict";
    if (opacity === void 0) { opacity = 1; }
    return [
        transition("void => *", [
            style({
                opacity: 0
            }),
            animate("0.2s ease-in-out", style({
                opacity: opacity
            }))
        ]),
        transition("* => void", [
            animate("0.2s ease-in-out", style({
                opacity: 0
            }))
        ])
    ];
}
//# sourceMappingURL=fade.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/utils/animations/fade/fade.js
// module id = 308
// module chunks = 4